import { useAnalytics } from '@melio/platform-analytics';
import { Bill } from '@melio/platform-api';
import { getDollarsFromCents } from '@melio/platform-utils';

export const useTrackInstantBillCreation = () => {
  const { track, trackMarketing } = useAnalytics();

  const trackInstantBillCreation = (bill: Pick<Bill, 'id' | 'amount'>) => {
    const action = 'SavedAndContinued';
    const properties = {
      BillId: bill.id,
      Amount: getDollarsFromCents(bill.amount || 0),
      PaymentFrequency: 'One Time',
      RecurringPaymentEndBy: null,
      RecurringPaymentEndValue: null,
    };
    track('AddBillInfo', action, properties);
    trackMarketing('bill-create_save-success', properties);
  };

  return { trackInstantBillCreation };
};
